<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex md12>
              <v-btn
                fixed
                direction="bottom"
                dark
                fab
                bottom
                right
                color="pink"
                @click="guardarMaterias"
                :disabled="horario.length <= 0"
                v-show="$mq !== 'sm'"
                large
              >
                <v-icon>save</v-icon>
              </v-btn>
                <v-card v-if="!cargandoDatos && !seleccionTerminada && !fueraDeTiempo">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Reinscripcion al semestre: {{periodo.semestre}}</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout>
                            <v-flex md6>
                                Por favor selecciona la actividad que deseas cursar.
                            </v-flex>
                        </v-layout>
                        <v-alert
                                :value="true"
                                color="info"
                                icon="info"
                                outline
                        >
                            Recuerda que debes de <strong>Guardar</strong> tu horario o de lo contrario no será oficial.
                        </v-alert>
                    </v-card-text>
                    <v-layout>
                        <v-flex xs12 sm6>
                            <v-card flat>
                                <v-toolbar color="indigo" dark flat>
                                    <v-toolbar-title>Actividades disponibles</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            placeholder="Buscar"
                                            single-line
                                            hide-details
                                            :append-icon="'search'"
                                            clearable
                                    ></v-text-field>
                                </v-toolbar>
                                <v-list three-line>
                                    <template v-for="item in filtering">
                                        <v-list-tile @click="verificaCupoGrupo(materiasDisponibles.indexOf(item))" ripple>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <span v-html="item.descripcion + ' - ' + item.grupo"></span>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <span>Créditos: {{item.creditos}} / Docente: {{item.docente}}</span><br>
                                                    <span v-if="item.horario[1]">L: {{ convertirHorario(item.horario[1]) }}</span>
                                                    <span v-if="item.horario[2]">M: {{ convertirHorario(item.horario[2]) }}</span>
                                                    <span v-if="item.horario[3]">MI: {{ convertirHorario(item.horario[3]) }}</span>
                                                    <span v-if="item.horario[4]">J: {{ convertirHorario(item.horario[4]) }}</span>
                                                    <span v-if="item.horario[5]">V: {{ convertirHorario(item.horario[5]) }}</span>
                                                    <span v-if="item.horario[6]">S: {{ convertirHorario(item.horario[6]) }}</span>
                                                    <span v-if="item.horario[7]">D: {{ convertirHorario(item.horario[7]) }}</span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>

                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-card flat>
                                <v-toolbar>
                                    <v-toolbar-title>Actividades Seleccionadas</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="resetSeleccion" flat v-if="horario.length">
                                        <v-icon>cached</v-icon>
                                        Volver a comenzar
                                    </v-btn>
                                </v-toolbar>
                                <v-list three-line>
                                    <template v-for="item in horario">
                                        <v-list-tile @click="quitaAlumno(horario.indexOf(item))" ripple>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <span v-html="item.descripcion + ' - ' + item.grupo"></span>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    <span>Créditos: {{item.creditos}} / Docente: {{item.docente}}</span><br>
                                                    <span v-if="item.horario[1]">L: {{ convertirHorario(item.horario[1]) }}</span>
                                                    <span v-if="item.horario[2]">M: {{ convertirHorario(item.horario[2]) }}</span>
                                                    <span v-if="item.horario[3]">MI: {{ convertirHorario(item.horario[3]) }}</span>
                                                    <span v-if="item.horario[4]">J: {{ convertirHorario(item.horario[4]) }}</span>
                                                    <span v-if="item.horario[5]">V: {{ convertirHorario(item.horario[5]) }}</span>
                                                    <span v-if="item.horario[6]">S: {{ convertirHorario(item.horario[6]) }}</span>
                                                    <span v-if="item.horario[7]">D: {{ convertirHorario(item.horario[7]) }}</span>
                                                </v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-layout>

                    <v-data-table
                            :headers="headers"
                            :items="horario"
                            hide-actions
                            class="mt-5"
                    >
                        <template slot="items" slot-scope="props">
                            <td>
                                <strong>{{props.item.descripcion}}</strong><br>
                                {{props.item.actividad}}
                            </td>
                            <td>{{props.item.grupo}}</td>
                            <td>{{ convertirHorario(props.item.horario[1]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[2]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[3]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[4]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[5]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[6]) }}</td>
                            <td>{{ convertirHorario(props.item.horario[7]) }}</td>
                        </template>
                    </v-data-table>
                  <v-data-table
                    :headers="headers"
                    :items="horarioEscolar"
                    hide-actions
                    class="mt-5 mb-5 pb-5"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <strong>{{props.item.materia.nombre}}</strong><br>
                        {{props.item.materia.clave}}<br>
                        {{props.item.materia.docente}}
                      </td>
                      <td>{{props.item.materia.grupo}}</td>
                      <td v-html="props.item.materia.horario[2]"></td>
                      <td v-html="props.item.materia.horario[3]"></td>
                      <td v-html="props.item.materia.horario[4]"></td>
                      <td v-html="props.item.materia.horario[5]"></td>
                      <td v-html="props.item.materia.horario[6]"></td>
                      <td v-html="props.item.materia.horario[7]"></td>
                      <td v-html="props.item.materia.horario[1]"></td>
                    </template>
                  </v-data-table>
                </v-card>
                <v-card v-if="seleccionTerminada && !fueraDeTiempo">
                    <v-card-title class="headline">
                      Tu actividad extraescolar ha sido agregada correctamente
                    </v-card-title>
                </v-card>
                <v-card v-if="!cargandoDatos && fueraDeTiempo">
                    <v-card-title class="headline">
                        Actividad ExtraEscolar
                    </v-card-title>
                    <v-card-text>
                        Te encuentras fuera de tiempo para seleccinar tu activida extraescolar, regresa más tarde.
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar.show"
                color="error"
                :timeout="snackbar.timeout"
                :vertical="true"
                :left="true"
                :top="true"
        >
            {{ snackbar.text }}
            <v-btn
                    dark
                    flat
                    @click="snackbar.show = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
        <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Cargando actividades disponibles</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="verificandoCupo" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Verificando el cupo del grupo.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="eliminandoGrupo" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Eliminando del grupo.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="guardandoMaterias" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Guardando actividad.</span>
                </v-card-title>
            </v-card>
        </v-dialog>
      <v-dialog v-model="showError" max-width="350px" persistent>
        <v-card>
          <v-card-title>
            <b>Ha ocurrido un problema.</b>
          </v-card-title>

          <v-card-text v-html="messageError">
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              flat
              @click="showError = false"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'

  export default {
    name: 'ReinscripcionPage',
    data: () => ({
      cargandoDatos: false,
      headers: [
        {
          text: 'Materia',
          align: 'left',
          value: 'materia'
        },
        { text: 'Gpo', value: 'grupo' },
        { text: 'Lunes', value: 'lunes' },
        { text: 'Martes', value: 'martes' },
        { text: 'Miércoles', value: 'miercoles' },
        { text: 'Jueves', value: 'jueves' },
        { text: 'Viernes', value: 'viernes' },
        { text: 'Sábado', value: 'sabado' },
        { text: 'Domingo', value: 'domingo' }
      ],
      horario: [],
      materiasDisponibles: [],
      periodo: {},
      search: '',
      materiaSeleccionada: '',
      verificandoCupo: false,
      eliminandoGrupo: false,
      guardandoMaterias: false,
      seleccionTerminada: false,
      fueraDeTiempo: false,
      snackbar: {
        show: false,
        timeout: 6000,
        text: ''
      },
      showError: false,
      messageError: '',
      horarioEscolar: [],
      diasExtraescolar: {
        1: 'Lunes',
        2: 'Martes',
        3: 'Míércoles',
        4: 'Jueves',
        5: 'Viernes',
        6: 'Sábado',
        7: 'Domingo'
      },
      diasEscolar: {
        2: 'Lunes',
        3: 'Martes',
        4: 'Míércoles',
        5: 'Jueves',
        6: 'Viernes',
        7: 'Sábado',
        1: 'Domingo'
      }
    }),
    created () {
      axios.get('alumno/horario')
        .then(request => {
          this.horarioEscolar = request.data.horario
        })

      const materiasDisponibles = JSON.parse(sessionStorage.getItem('materiasDisponibles_extra'))

      if (materiasDisponibles) {
        this.periodo = JSON.parse(sessionStorage.getItem('periodo'))
        this.horario = JSON.parse(sessionStorage.getItem('horario_extra')) || []
        this.materiasDisponibles = materiasDisponibles
        this.seleccionTerminada = JSON.parse(sessionStorage.getItem('seleccionTerminada_extra')) || false
        this.fueraDeTiempo = JSON.parse(sessionStorage.getItem('fueraDeTiempo_extra')) || false
      } else {
        this.getGruposDisponibles()
      }
    },
    computed: {
      filtering () {
        if (this.search) {
          return this.materiasDisponibles.filter((item) => {
            return (item.descripcion.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) ||
              (item.actividad.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) ||
              (item.grupo.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
          })
        }

        return this.materiasDisponibles
      }
    },
    methods: {
      moverAHorario: function (index) {
        this.search = ''

        const grupo = this.materiasDisponibles[index]

        if (index >= 0) {
          this.horario.push(grupo)
          this.materiasDisponibles.splice(index, 1)
        } else {
          for (let cont = 0; cont < this.materiasDisponibles.length; cont++) {
            this.horario.push(this.materiasDisponibles[cont])
          }
          this.materiasDisponibles.splice(0, this.materiasDisponibles.length)
        }

        sessionStorage.setItem('horario_extra', JSON.stringify(this.horario))
        sessionStorage.setItem('materiasDisponibles_extra', JSON.stringify(this.materiasDisponibles))
      },
      moverAMateriasDisponibles: function (index) {
        this.search = ''
        const grupo = this.horario[index]
        if (index >= 0) {
          this.materiasDisponibles.push(grupo)
          this.horario.splice(index, 1)
        } else {
          for (let cont = 0; cont < this.horario.length; cont++) {
            this.materiasDisponibles.push(this.horario[cont])
          }
          this.horario.splice(0, this.horario.length)
        }

        sessionStorage.setItem('horario_extra', JSON.stringify(this.horario))
        sessionStorage.setItem('materiasDisponibles_extra', JSON.stringify(this.materiasDisponibles))
      },
      getGruposDisponibles () {
        this.cargandoDatos = true
        axios.get('alumno/extra-escolar')
          .then(request => {
            const materiasSeleccionadasAnteriormente = request.data.materiasSeleccionadasAnteriormente
            const that = this

            this.cargandoDatos = false
            this.materiasDisponibles = request.data.grupos
            this.periodo = request.data.periodo
            this.seleccionTerminada = request.data.seleccionTerminada
            this.fueraDeTiempo = request.data.fueraDeTiempo

            sessionStorage.setItem('periodo', JSON.stringify(this.periodo))
            sessionStorage.setItem('fueraDeTiempo_extra', JSON.stringify(this.fueraDeTiempo))

            materiasSeleccionadasAnteriormente.forEach(function (item) {
              const materia = that.materiasDisponibles.filter(function (grupo) {
                if (item == null || item.actividad === null || item.actividad === undefined) {
                  return false
                }

                return (grupo.actividad.toLowerCase().indexOf(item.actividad.toLowerCase()) !== -1) &&
                  (grupo.grupo.toLowerCase().indexOf(item.grupo.toLowerCase()) !== -1)
              })

              if (materia.length) {
                that.moverAHorario(that.materiasDisponibles.indexOf(materia.pop()))
              }
            })
          })
      },
      convertirHorario (horario) {
        if (horario.horaInicial === undefined) {
          return ''
        }

        return horario.horaInicial + ' - ' + horario.horaFinal + ' (' + horario.aula + ')'
      },

      verificaCupoGrupo (index) {
        this.verificandoCupo = true
        const grupo = this.materiasDisponibles[index]

        this.validaHorarios(grupo)
          .then(() => {
            axios.post('alumno/extra-escolar/verifica-cupo', {
              grupo: grupo.grupo,
              actividad: grupo.actividad,
              periodo: this.periodo.periodo
            })
              .then(() => {
                this.verificandoCupo = false
                this.moverAHorario(index)
              })
              .catch(err => {
                console.log('No se pudo reservar el cupo en el grupo')
                console.log(err.response.data)
                this.verificandoCupo = false
                this.showError = true
                this.messageError = err.response.data.detail
              })
          })
          .catch(error => {
            console.error('cruce de horario')
            console.error(error)
            this.showError = true
            this.messageError = `La actividad <b>${grupo.descripcion}</b> tiene cruce de horas con <b>${error.materia.nombre}</b> el día ${error.diaEscolar}`
          })
          .finally(() => {
            this.verificandoCupo = false
          })
      },
      validaHorarios (grupo) {
        return new Promise((resolve, reject) => {
          for (let index in grupo.horario) {
            const horario = grupo.horario[index]
            if (horario !== '' && horario !== null && horario !== undefined) {
              const horaInicial = moment(horario.horaInicial, 'HH:mm')
              const horaFinal = moment(horario.horaFinal, 'HH:mm')

              this.horarioEscolar.forEach(item => {
                for (let indexEscolar in item.materia.horario) {
                  const horarioEscolar = item.materia.horario[indexEscolar]
                  if (horarioEscolar !== '' && horarioEscolar !== null && horarioEscolar !== undefined) {
                    const horaInicialEscolar = moment(horarioEscolar.substring(0, 5), 'HH:mm')
                    const horaFinalEscolar = moment(horarioEscolar.substring(8, 13), 'HH:mm')
                    if (horaInicial.isValid() && horaFinal.isValid() &&
                      horaInicialEscolar.isValid() && horaFinalEscolar.isValid() &&
                      this.diasExtraescolar[index] === this.diasEscolar[indexEscolar]) {
                      let cruceHorarios = horaInicialEscolar.isBetween(horaInicial, horaFinal, null, '[)') || horaInicial.isBetween(horaInicialEscolar, horaFinalEscolar, null, '[)')

                      if (!cruceHorarios) {
                        cruceHorarios = horaFinalEscolar.isBetween(horaInicial, horaFinal, null, '(]') || horaFinal.isBetween(horaInicialEscolar, horaFinalEscolar, null, '(]')
                      }

                      if (cruceHorarios) {
                        const data = {
                          materia: item.materia,
                          horaInicial,
                          horaFinal,
                          horaInicialEscolar,
                          horaFinalEscolar,
                          diaExtrascolar: this.diasExtraescolar[index],
                          diaEscolar: this.diasEscolar[indexEscolar]
                        }
                        reject(data)
                      }
                    }
                  }
                }
              })
            }
          }
          resolve()
        })
      },
      quitaAlumno (index) {
        this.eliminandoGrupo = true
        const grupo = this.horario[index]

        axios.post('alumno/extra-escolar/quita-alumno', {grupo: grupo.grupo, actividad: grupo.actividad, periodo: this.periodo.periodo})
          .then(() => {
            this.eliminandoGrupo = false
            this.moverAMateriasDisponibles(index)
          })
          .catch(err => {
            this.eliminandoGrupo = false
            console.log('No se pudo eliminar de la actividad')
            console.log(err.data)
          })
      },
      resetSeleccion () {
        this.eliminandoGrupo = true
        console.log('RESET')
        const horarios = this.horario.map(grupo => {
          return new Promise((resolve, reject) => {
            axios.post('alumno/extra-escolar/quita-alumno', {grupo: grupo.grupo, materia: grupo.clave, periodo: this.periodo.periodo})
              .then(() => {
                console.log('eliminando grupo')
                const index = this.horario.indexOf(grupo)
                this.moverAMateriasDisponibles(index)
                resolve()
              })
              .catch(err => {
                console.log('No se pudo eliminar de la actividad')
                console.log(err.data)
                resolve()
              })
          })
        })

        Promise.all(horarios)
          .then(() => {
            this.eliminandoGrupo = false
          })
          .catch(() => {
            this.eliminandoGrupo = false
          })
      },
      guardarMaterias () {
        if (this.horario.length) {
          this.guardandoMaterias = true
          axios.post('alumno/extra-escolar/guardar', {horario: this.horario, periodo: this.periodo.periodo})
            .then(response => {
              this.guardandoMaterias = false
              this.seleccionTerminada = true
              sessionStorage.setItem('seleccionTerminada_extra', this.seleccionTerminada)
              console.log(response.data)
            })
            .catch(err => {
              console.log(err.data)
            })
        }
      }
    }
  }
</script>

<style scoped>
    .v-list.v-list--three-line {
        max-height: 600px;
        overflow-y: auto;
    }

    .v-chip--x-small {
        font-size: 10px;
        height: 16px;
    }

    .v-chip--x-small .v-chip__content {
        line-height: 1;
        padding: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/inscripciones/ExtraEscolarPage.vue